module.exports = __webpack_public_path__ + "img/score_03.f079f09d.svg";